import { Editor } from "@tinymce/tinymce-react";
import { message } from "antd";
import { useRef } from "react";
import { apiClient, configService } from "../services";

// Custom image upload handler
const customImageUploadHandler = (blobInfo: any, progress: any) => {
  return new Promise((resolve, reject) => {
    // Create form data for upload
    const formData = new FormData();
    formData.append("image", blobInfo.blob(), blobInfo.filename());

    // API upload configuration
    configService
      .uploadFile(blobInfo.blob())
      .then((response: any) => {
        console.log('[DEBUG] (👉ﾟヮﾟ)👉  ~ customImageUploadHandler  ~ response:', response)
        // Assuming API returns { url: string, name: string }
        const { file, image, id } = response?.data?.data;
        const path = file
        const name = image
        // Save upload information to localStorage
        try {
          const savedImages = JSON.parse(
            localStorage.getItem("uploadedImages") || "[]",
          );

          const newImage = {
            id: Date.now(),
            name: name,
            url: path,
            timestamp: new Date().toISOString(),
          };

          savedImages.push(newImage);

          // Limit to last 50 images
          if (savedImages.length > 50) {
            savedImages.shift();
          }

          localStorage.setItem("uploadedImages", JSON.stringify(savedImages));
        } catch (error) {
          console.error("Failed to save image metadata", error);
        }

        // Resolve with the server image URL
        console.log("[DEBUG] (👉ﾟヮﾟ)👉  ~ .then  ~ path:", path);
        resolve(path);
      })
      .catch((error) => {
        // Handle upload error
        message.error("Image upload failed");
        reject(error);
      });
  });
};

// Saved Images Gallery Component
// const SavedImagesGallery = () => {
//   const getSavedImages = () => {
//     try {
//       return JSON.parse(localStorage.getItem('uploadedImages') || '[]');
//     } catch (error) {
//       console.error('Error retrieving images', error);
//       return [];
//     }
//   };

//   return (
//     <div className="grid grid-cols-4 gap-4 mt-4">
//       {getSavedImages().map((image) => (
//         <div key={image.id} className="border rounded overflow-hidden">
//           <img src={image.data} alt={image.name} className="w-full h-32 object-cover" />
//           <div className="p-2 text-xs text-center truncate">{image.name}</div>
//         </div>
//       ))}
//     </div>
//   );
// };

// Rich Text Editor Component
const RichTextEditorTiny = ({
  value,
  onChange,
  placeholder = "Write your content here...",
}: {
  value?: any;
  onChange?: any;
  placeholder?: string;
}) => {
  const editorRef = useRef<Editor>(null);

  return (
    <div>
      {/* config editor with convert style to inline style when paste */}
      <Editor
        // apiKey={null} // No API key needed for self-hosted
        tinymceScriptSrc="/tinymce_7.6.0/tinymce/js/tinymce/tinymce.min.js"
        onInit={(evt, editor) => {
          if (editorRef.current) {
            editorRef.current = editor;
          }
        }}
        value={value}
        init={{
          height: 500,
          menubar: true,
          promotion: false,
          statusbar: false,
          plugins: [
            "advlist",
            "autolink",
            "lists",
            "link",
            "image",
            "charmap",
            "preview",
            "anchor",
            "searchreplace",
            "visualblocks",
            "fullscreen",
            "insertdatetime",
            "media",
            "table",
            "help",
            "wordcount",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic forecolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "link image media | " +
            "removeformat | help",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",

          // Self-hosted TinyMCE script source
          tinymceScriptSrc: "/tinymce_7.6.0/tinymce/js/tinymce/tinymce.min.js",

          // Custom image upload handler
          images_upload_handler: customImageUploadHandler,
          directionality: "ltr",
          // Enable paste of images
          paste_data_images: true,
          relative_urls: false,
          remove_script_host: false,
          paste_process_styles: true,
          paste_retain_style_properties: true,
          paste_webkit_styles: "all",
          convert_urls: true,
          // config paste convert style to inline style
          paste_convert_styles: true,
          // Image upload settings
          images_upload_url: false, // Disable default upload
          automatic_uploads: true,
        }}
        onEditorChange={(content) => {
          if (onChange) {
            onChange(content);
          }
        }}
      />

      {/* Saved Images Gallery */}
      {/* <SavedImagesGallery /> */}
    </div>
  );
};

export default RichTextEditorTiny;
